import { WholesaleCatalogType } from '@cbgms/api'
import { isRequired } from '@cbgms/base/utils/validations'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox, TextField } from '@carsys/form'
import { useFormikContext } from 'formik'
import { IFormValues } from './types'
import { Divider } from '@mui/material'

export const hasVPOMFields = (selectedCatalogType: WholesaleCatalogType) => Boolean(selectedCatalogType === WholesaleCatalogType.VPOM)

export const CatalogFieldsVPOM = () => {
  const { t } = useTranslation()
  const {
    values: { wholesaleCatalogType }
  } = useFormikContext<IFormValues>()
  const renderVPOMProductTreeInput = useMemo(() => hasVPOMFields(wholesaleCatalogType), [wholesaleCatalogType])

  if (!renderVPOMProductTreeInput) return null
  return (
    <>
      <TextField validate={isRequired} required name='VPOMProductTreeID' label={t('wholesaler-catalog.VPOMProductTreeID')} />
      <TextField name='RemoteIDOverride' label={t('wholesaler-catalog.RemoteIDOverride')} />
      <TextField name='ExhaustGroupPlaceholder' label={t('wholesaler-catalog.VPOMExhaustGroupUUID')} />
      <TextField name='SteeringGroupPlaceholder' label={t('wholesaler-catalog.VPOMSteeringGroupUUID')} />
      <Checkbox name='VPOMUseDevelopmentAPI' label={t('wholesaler-catalog.MDMUseDevelopAPI')} />
      <Checkbox name='VPOMHidePDHForNonTyres' label={t('wholesaler-catalog.VPOMHidePDHForNonTyres')} />
      <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
    </>
  )
}
